import React, {useEffect, useState, useContext} from 'react';
import './products.css';
import { Container } from 'react-bootstrap';
import BestDeals from './bestDeals/BestDeals';
import TopPerformer from './topPerformer/TopPerformer';
import MostPopular from './mostPopular/MostPopular';
import RecentlyViewed from './recent/RecentlyViewed';
import UserContext from '../../../context/UserContext';
import axios from 'axios';
import ExportApi from "../../../api/ExportApi";
import bannerImage from "../../../assets/img/main_banners.jpg"

export default function Products({ productsData, apiEndpoint }) {
    const userId = JSON.parse(localStorage.getItem("tokenuser"))?.id;
   
  const { setNewlySelectedProducts } = useContext(UserContext);
  useEffect(() => {
    if (!userId) {

      return;
    }
    ExportApi.favouriteList(userId)
      .then(function (response) {

        setNewlySelectedProducts(response?.data?.data?.favourite);
      })
      .catch(function (error) {
        console.log(error);
      })
  }, [userId])
    
    return(
        <div className="products-container">
            <Container>
                <BestDeals productsData={productsData} />
                <TopPerformer productsData={productsData} />
                <div className='py-2' style={{height : "auto" , width : "100%"}}>
                  <img style={{height : "100%" , width : "100%"}} src={bannerImage}/>
                </div>
                <MostPopular productsData={productsData} />
                 <div style={userId ? { minHeight: '300px', height: 'auto' } : {}}> 
                {userId && (
                  <RecentlyViewed productsData={productsData} />
                )}
              </div>
            </Container>
        </div>
    )
}